import { Action } from 'redux';
import { jwPlayerActions } from './actions-const';

export function setIsJWPlayerActive(payload: boolean): Action<string> & { payload: boolean } {
  return {
    type: jwPlayerActions.SET_IS_ACTIVE,
    payload,
  };
}
